import * as React from "react";
import { EventPrePacksContent } from "./EventPrePacksContent";
import { LeaguePrePacksContent } from "./LeaguePrePacksContent";
const PrePacksContentMap = {
    Event(props) { return React.createElement(EventPrePacksContent, Object.assign({}, props)); },
    League(props) { return React.createElement(LeaguePrePacksContent, Object.assign({}, props)); },
};
export function PrePacksContent({ type, props }) {
    return PrePacksContentMap[type](props);
}
//# sourceMappingURL=PrePacksContent.js.map